'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = 'M576 287.6l-64.2 0 1 224.4L472 512l-16 0-104 0 0-160-128 0 0 160-104 0-16 0-39.9 0 0-37.2c-.1-.9-.1-1.8-.1-2.8l0-112c0-.9 0-1.9 .1-2.8l0-69.7L0 287.6 0 240 288.4 0 416 106.5 416 32l96 0 0 154.6L576 240l0 47.6z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;